import React, {useEffect, useState, useRef, useCallback, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
    Image,
    Menu,
    Input,
    Form,
    Icon,
    Button,
    Dropdown,
    Modal,
    Divider,
    Grid,
    GridRow,
    GridColumn,
    FormField,
    Sidebar, SidebarPusher, ModalActions, Popup
} from 'semantic-ui-react';
import { Spin } from 'antd';
import { LoadingOutlined, GiftFilled } from '@ant-design/icons';

import config from '../../config/config';
import {
    fetchCategoriesList,
    categoriesSelectors,
} from '../../features/categories';
import { fetchSecondaryMenu, secondaryMenuSelectors } from '../../features/secondaryMenu';
import {
    openSearch,
    closeSearch,
    setFormChanged,
    resetFormChanged,
    sendEmail,
    CONSUMER_KEY, CONSUMER_SECRET, setCountry, setRegion,
    closeMenu,
    closeAuth,
} from '../../features/ui';
import { selectLocalUserData, selectAuthVisible } from '../../features/ui/selectors';
import './NavBar.css';
import {BrowserView, isMobile, MobileView} from 'react-device-detect';
import { SEARCH_CONTEXTS, setSearchContext } from "../../features/search";
import { selectSearchToContext } from "../../features/search/selectors";
import { ReactComponent as LoginIcon} from "../../icons/login-icon.svg";
import { ReactComponent as CloseIcon} from "../../icons/close-icon.svg";
import { ReactComponent as BurgerMenu} from "../../icons/burger-menu-icon.svg";
import { ReactComponent as GeoIcon } from "../../icons/geo-icon.svg";
import { ReactComponent as HeartIcon } from "../../icons/heart-icon.svg";
import { ReactComponent as CartIcon } from "../../icons/cart-icon-outline.svg";
import LogoEfeed from "../../icons/logo-efeed.png"
import UserIcon from "../../icons/user-icon.png";
import PhoneCountryMask from "../../features/address/PhoneCountryMask";
import RegionSelector from '../../features/geolocation/RegionSelector';
import { ReactComponent as SearchIcon } from "../../icons/search-icon.svg";
import { ReactComponent as HomeIcon } from "../../icons/home-icon.svg";

import {
    fetchCountries,
    addressActions,
    addressSelectors,
} from '../../features/address'
import lowerCase from "lodash/lowerCase";
import LanguageModal from "../LanguageModal/LanguageModal";
import { selectLanguage } from "../../features/language/selectors";
import { setLanguage } from "../../features/language/actions";
import {toastr} from "react-redux-toastr";
import { clearCompSearch, setCompSearch } from "../../features/companies";
import translations from "../LanguageModal/translations";

import SearchForm from "../../components/SearchForm";
import { MobileSearchForm } from "../../components/SearchForm";
import {selectCountries} from "../../features/address/selectors";
import AuthModal from "../../features/auth/AuthModal";
import { selectIsLoggedIn, selectUserDisplayName, selectToken as selectAuthToken } from "../../features/auth/selectors";
import { cartSelectors } from "../../features/cart";
import { fetchBonuses, bonusesSelectors } from "../../features/bonuses";

export const MobileSidebar = (props) => {
    const {
        sidebarVisible,
        setSidebarVisible,
        activeSubmenu,
        handleCategoryClick,
        handleSimpleCategoryClick,
        searchState,
        setSearch,
        handleSubmit,
        navigate,
    } = props;

    const secondaryMenuItems = useSelector(secondaryMenuSelectors.selectSecondaryMenuItems);

    const { menuItems, submenuData } = useMemo(() => {
        if (!secondaryMenuItems || secondaryMenuItems.length === 0) {
            return { menuItems: [], submenuData: {} };
        }
        const topLevel = secondaryMenuItems
            .filter(item => item.parent === 0)
            .sort((a, b) => a.order - b.order);

        const childrenOf = (parentId) =>
            secondaryMenuItems
                .filter(item => item.parent === parentId)
                .sort((a, b) => a.order - b.order);

        const items = [];
        const subData = {};

        topLevel.forEach(item => {
            const key = String(item.id);
            const children = childrenOf(item.id);

            items.push({
                id: item.id,
                object_id: item.object_id,
                name: item.title,
                key,
                url: item.url,
                hasSubmenu: children.length > 0,
            });

            if (children.length > 0) {
                subData[key] = {
                    title: item.title,
                    columns: children.map(child => ({
                        id: child.id,
                        object_id: child.object_id,
                        title: child.title,
                        url: child.url,
                        items: [],
                    })),
                };
            }
        });

        return { menuItems: items, submenuData: subData };
    }, [secondaryMenuItems]);

    const getMenuPath = (menuItem) => {
        return `/products/${menuItem.object_id}`;
    };

    return (
        <Sidebar
            as={Menu}
            animation='overlay'
            onHide={() => setSidebarVisible(false)}
            vertical
            visible={sidebarVisible}
            direction='right'
            className='mobile-menu-sidebar'
        >
            <div className="mobile-menu-container">
                <div className="mobile-menu-header">
                    <button className="mobile-menu-close-btn" aria-label="Закрыть меню" onClick={() => setSidebarVisible(false)}>
                        <CloseIcon />
                    </button>
                </div>

                <div className="mobile-menu-region">
                    <RegionSelector />
                </div>

                <div className="mobile-menu-content">
                    <MobileSearchForm onClose={() => setSidebarVisible(false)} />

                    <div className="mobile-menu-categories">
                        {menuItems.map((item) => (
                            <div key={item.key} className="mobile-category-item">
                                {item.hasSubmenu ? (
                                    <>
                                        <div
                                            className={`mobile-category-header ${activeSubmenu === item.key && submenuData[item.key] ? 'active' : ''}`}
                                            onClick={(e) => handleCategoryClick(e, item.key)}
                                        >
                                            <span>{item.name}</span>
                                        </div>
                                        {activeSubmenu === item.key && submenuData[item.key] && (
                                            <div className="mobile-submenu">
                                                <div
                                                    className="mobile-submenu-all"
                                                    onClick={() => {
                                                        if (navigate) navigate(getMenuPath(item));
                                                        setSidebarVisible(false);
                                                    }}
                                                >
                                                    Смотреть всё
                                                </div>
                                                {submenuData[item.key].columns.map((column) => (
                                                    <div key={column.id} className="mobile-submenu-column">
                                                        <div
                                                            className="mobile-submenu-title"
                                                            onClick={() => {
                                                                if (navigate) navigate(getMenuPath(column));
                                                                setSidebarVisible(false);
                                                            }}
                                                        >
                                                            {column.title}
                                                        </div>
                                                        {column.items.map((subItem) => (
                                                            <div
                                                                key={subItem.id}
                                                                className="mobile-submenu-item"
                                                                onClick={() => {
                                                                    if (navigate) navigate(getMenuPath(subItem));
                                                                    setSidebarVisible(false);
                                                                }}
                                                            >
                                                                {subItem.name}
                                                            </div>
                                                        ))}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <div
                                        className="mobile-category-header no-submenu"
                                        onClick={() => {
                                            if (navigate) navigate(getMenuPath(item));
                                            setSidebarVisible(false);
                                        }}
                                    >
                                        <span>{item.name}</span>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Sidebar>
    );
};

export default function NavTopBar(props) {
    const {
        dispatch,
        navigate,
        userData,
        userLocation,
        location,
        mixpanel,
        token,
        setSidebarVisible,
    } = props;

    const {
        selectAddressFields,
        selectCountries,
        selectIsCountriesFetching
    } = addressSelectors;

    const [ openRegionPopup, setOpenRegionPopup ] = useState(false);
    const [ openRegionNotLogin, setOpenRegionNotLogin ] = useState(false);

    const [ openQuestionPopup, setOpenQuestionPopup ] = useState(false);
    const [ isAuthModalOpen, setIsAuthModalOpen ] = useState(false);

    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const [messageValue, setMessageValue] = useState('');
    const [name, setName] = useState("");
    const [nameDirty, setNameDirty] = useState(false);

    const languageDispatch = useDispatch();
    const language = useSelector(selectLanguage);
    const languageString = language[0]+language[1];

    const t = (key) => {
        const languageString = language[0]+language[1];
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };

    const [mail, setMail] = useState("");
    const [mailDirty, setMailDirty] = useState(false);
    const [mailError, setMailError] = useState(t("theInputFieldCannotBeEmpty"));

    const [textQuestion, setTextQuestion] = useState("");
    const [textDirty, setTextDirty] = useState(false);
    const [textError, setTextError] = useState(t("theInputFieldCannotBeEmpty"));
    const [phoneNumber, setPhoneNumber] = useState("");
    const [userName, setUserName] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [activeSubmenu, setActiveSubmenu] = useState(null);
    const [isSearchExpanded, setIsSearchExpanded] = useState(false);

    // Close search when screen shrinks to mobile (burger appears)
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 768 && isSearchExpanded) {
                setIsSearchExpanded(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [isSearchExpanded]);

    const [formValid, setFormValid] = useState(false);
    const [phoneNumberContainsUnderscore, setPhoneNumberContainsUnderscore] = useState(true);

    const authVisible = useSelector(selectAuthVisible);
    const isNewAuthLoggedIn = useSelector(selectIsLoggedIn);
    const newAuthDisplayName = useSelector(selectUserDisplayName);
    const newAuthToken = useSelector(selectAuthToken);
    const searchContext = useSelector(selectSearchToContext);
    const countries = useSelector((state) => selectCountries(state));
    const fields = useSelector((state) => selectAddressFields(state));
    const isFetching = useSelector((state) => selectIsCountriesFetching(state));
    const localData = useSelector(selectLocalUserData);
    const categoriesItems = useSelector(categoriesSelectors.selectCategoriesItems);
    const secondaryMenuItems = useSelector(secondaryMenuSelectors.selectSecondaryMenuItems);
    const isSecondaryMenuLoading = useSelector(secondaryMenuSelectors.selectSecondaryMenuLoading);
    const cartCount = useSelector(cartSelectors.selectCartTotalQuantity);
    const bonusPoints = useSelector(bonusesSelectors.selectPointsActive);

    useEffect(() => {
        if (isNewAuthLoggedIn) {
            dispatch(fetchBonuses());
        }
    }, [isNewAuthLoggedIn]);

    const [searchState, setSearchState] = useState({ search: '', context: searchContext });

    const { menuItems, submenuData } = useMemo(() => {
        if (!secondaryMenuItems || secondaryMenuItems.length === 0) {
            return { menuItems: [], submenuData: {} };
        }
        const topLevel = secondaryMenuItems
            .filter(item => item.parent === 0)
            .sort((a, b) => a.order - b.order);

        const childrenOf = (parentId) =>
            secondaryMenuItems
                .filter(item => item.parent === parentId)
                .sort((a, b) => a.order - b.order);

        const items = [];
        const subData = {};

        topLevel.forEach(item => {
            const key = String(item.id);
            const children = childrenOf(item.id);

            items.push({
                id: item.id,
                object_id: item.object_id,
                name: item.title,
                key,
                url: item.url,
                hasSubmenu: children.length > 0,
            });

            if (children.length > 0) {
                subData[key] = {
                    title: item.title,
                    columns: children.map(child => ({
                        id: child.id,
                        object_id: child.object_id,
                        title: child.title,
                        url: child.url,
                        items: [],
                    })),
                };
            }
        });

        return { menuItems: items, submenuData: subData };
    }, [secondaryMenuItems]);
    const [formData, setFormData] = useState({
        first_name: userData && userData.billing ? userData.billing.first_name : '',
        last_name: userData && userData.billing ? userData.billing.last_name : '',
        email: userData && userData.billing ? userData.billing.email : '',
        phone: userData && userData.billing ? userData.billing.phone : '',
        phone_country: userData && userData.billing ? userData.billing.phone_country : '',
        country: userData && userData.billing ? userData.billing.country : '',
        city: userData && userData.billing ? userData.billing.city : '',
        state: userData && userData.billing ? userData.billing.state : '',
        id: userData && userData.billing ? userData.billing.id : ''
    });

    // console.log(formData, userData);

    let listPhoneCountries = [];
    if (!isFetching && countries && countries.countries) {
        listPhoneCountries = Object.values(countries.countries).map((element, index) => (
            {
                key:  index,
                text: element.country_ru,
                flag: lowerCase(element.iso),
                value: element.iso,
                className: "dropdown-item",
                phone_mask: element.phone_mask,
            }
        ));
    }

    const [regionList, setRegionList] = useState({});
    //const phoneMask = listPhoneCountries.find(item => item.value === formData.phone_country)?.phone_mask;

    const arrayCountries = countries && countries.countries ? Object.values(countries.countries).map(country => ({
        'key': country.iso.toLowerCase(),
        'value': country.iso.toLowerCase(),
        'flag': country.iso.toLowerCase(),
        'text': languageString === 'ru' ? country.country_ru : country.country_en,
        'states': country.states
    })) : [];

    useEffect(() => {
        setSearchState({
            search: '',
            context: searchContext,
        });
    }, [props]);

    useEffect(() => {
        handleCheckCountry(null, {value: formData.country});
        if (!countries || !countries.countries) {
            dispatch(fetchCountries());
        }
        if (!categoriesItems || categoriesItems.length === 0) {
            dispatch(fetchCategoriesList({ filters: { per_page: 100 } }));
        }
        if (!secondaryMenuItems || secondaryMenuItems.length === 0) {
            dispatch(fetchSecondaryMenu());
        }
    }, []);

    useEffect(() => {
        if (mailError) {
            setFormValid(false)
        } else {
            setFormValid(true)
        }
    }, [mailError]);

    const mailHandler = (e) => {
        setMail(e.target.value);
        const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if (!re.test(String(e.target.value).toLowerCase())) {
            setMailError("Некорректный email адрес")
        } else {
            setMailError("")
        }
    }

    const handleCategoryClick = (e, categoryName) => {
        e.stopPropagation();
        setActiveSubmenu(activeSubmenu === categoryName ? null : categoryName);
    };

    const handleSimpleCategoryClick = (path) => {
        setActiveSubmenu(null);
        if (path) {
            navigate(path);
        }
    };

    const getMenuItemPath = (item) => {
        return `/products/${item.object_id}`;
    };

    const menuRef = useRef(null);
    const isDragging = useRef(false);
    const startX = useRef(0);
    const scrollLeft = useRef(0);
    const hasDragged = useRef(false);
    const submenuTimeout = useRef(null);

    const openSubmenu = (key) => {
        if (submenuTimeout.current) clearTimeout(submenuTimeout.current);
        setActiveSubmenu(key);
    };

    const closeSubmenuDelayed = () => {
        submenuTimeout.current = setTimeout(() => setActiveSubmenu(null), 150);
    };

    const handleMouseDown = (e) => {
        isDragging.current = true;
        hasDragged.current = false;
        startX.current = e.pageX - menuRef.current.offsetLeft;
        scrollLeft.current = menuRef.current.scrollLeft;
        menuRef.current.classList.add('dragging');
    };

    const handleMouseMove = (e) => {
        if (!isDragging.current) return;
        e.preventDefault();
        const x = e.pageX - menuRef.current.offsetLeft;
        const walk = x - startX.current;
        if (Math.abs(walk) > 3) hasDragged.current = true;
        menuRef.current.scrollLeft = scrollLeft.current - walk;
    };

    const handleMouseUp = () => {
        isDragging.current = false;
        if (menuRef.current) menuRef.current.classList.remove('dragging');
    };

    useEffect(() => {
        document.addEventListener('mouseup', handleMouseUp);
        document.addEventListener('mousemove', handleMouseMove);
        return () => {
            document.removeEventListener('mouseup', handleMouseUp);
            document.removeEventListener('mousemove', handleMouseMove);
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = () => {
            if (activeSubmenu) {
                setActiveSubmenu(null);
            }
        };

        if (activeSubmenu) {
            document.addEventListener('click', handleClickOutside);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [activeSubmenu]);

    const handleSubmitQuestion = () => {
        if (messageValue && phoneNumber && userName && mail) {
            dispatch(putTicket(token, 'Вопрос через VENUE от ' + ' ' + userName, messageValue, userName, 'a.burenko@feedtech.su', mail, phoneNumber ))
            setOpenQuestionPopup(false)
            setMessageValue('')
            setMail('')
            setPhoneNumber('')
        }
        // else if (!token && messageValue && phoneNumber && userName && mail) {
        //     setOpenQuestionPopup(false)
        //     setMessageValue('')
        //     setMail('')
        //     setPhoneNumber('')
        // }

        if (!phoneNumber || !userName || !mail || !messageValue) {
            toastr.warning(`Пожалуйста, заполните все поля`)
        }

    }

    const handleUserNameChange = (e) => {
        setUserName(e.target.value);
    }

    const blurHandler = (e) => {
        switch (e.target.name) {
            case 'mail':
                setMailDirty(true);
                break;
            case 'name':
                setNameDirty(true);
                break;
            case 'question':
                setTextDirty(true);
                break;
        }
    }

    const handleChangeField = (fieldName, value) => {
        if (value.includes('_')) {
            setPhoneNumberContainsUnderscore(true);
        } else {
            setPhoneNumberContainsUnderscore(false);
        }
        setPhoneNumber(value);
        // console.log('phone -', phoneNumber);
    }

    function handleSubmit() {
        setSidebarVisible(false)
        dispatch(closeSearch());
        dispatch(setSearchContext(searchState.context));
        navigate(`/search?q=${encodeURIComponent(searchState.search)}`, {state: {doQuery: true}});
        if (mixpanel)
            mixpanel.track('Search Confirm', { ...userLocation, ...userData, ...searchState });
    }

    function setSearch(e) {
        setSearchState({ ...searchState, search: e.target.value });
    }

    function handleOpenAuth() {
        setIsAuthModalOpen(true);
        if (mixpanel)
            mixpanel.track('Auth Open Form', { ...userLocation, ...userData });
    }

    function handleCloseAuth() {
        setIsAuthModalOpen(false);
        dispatch(closeAuth());
    }

    function handleSelectContext(e, data) {
        setSearchState({ ...searchState, context:data.value });
    }

    function goBack() {
        navigate( -1 );
    }

    function handleChangeSearch(e) {
        // console.log('handleChangeSearch' ,e);

        setSearchState({ search: e.target.value });
        if (e.target.value.length >= 3) {
            dispatch(setCompSearch(e.target.value));
        } else if (e.target.value.length < 3) {
            dispatch(clearCompSearch());
        }
    }

    const searchFormHeader = () => (
        <>
            <MobileView>
                {/*<Form onSubmit={handleSubmit} className="search-form mobile header-search">*/}
                {/*    <Input*/}
                {/*        type='search'*/}

                {/*        name="search"*/}
                {/*        className="search"*/}
                {/*        value={searchState.search}*/}
                {/*        onChange={setSearch}*/}
                {/*        // autoFocus={true}*/}
                {/*    >*/}
                {/*        <input className="search-field header-search-field"/>*/}
                {/*        <Button  className="search-button" type="submit" icon="search" />*/}
                {/*    </Input>*/}
                {/*</Form>*/}
                {location.pathname === '/congress-online'
                    ? <Form onSubmit={handleSubmit} className="search-form-congress mobile header-search">
                        <input
                            type='search'
                            placeholder={t('searchBySuppliers')}
                            name="search"
                            className="search-field-congress"
                            value={searchState.search}
                            onChange={handleChangeSearch}
                            autoFocus={false}
                            autoComplete="off"

                        >
                            {/*<input className="search-field"/>*/}
                            {/*<Button className="search-button" onClick={() => closeSearchInput()}  type="submit" icon="search"/>*/}
                        </input>
                    </Form>
                    : <Form onSubmit={handleSubmit} className="search-form">
                        <Dropdown
                            className="search-dropdown"
                            options={SEARCH_CONTEXTS(language)}
                            value={searchState.context}
                            onChange={handleSelectContext}
                        />
                        <Input
                            type='search'
                            placeholder={t('search')}
                            name="search"
                            className="search"
                            value={searchState.search}
                            onChange={setSearch}
                            // autoFocus={true}
                        >

                            <input className="search-field"/>

                            <Button  className="search-button" type="submit" icon="search" />
                        </Input>
                    </Form>}
            </MobileView>
        </>
    );

    const checkFormChanges = () => {
        const formFields = ['first_name', 'last_name', 'email', 'phone_country' ,'phone', 'country', 'city' ];
        const isAvatarChanged = formData?.['avatar'] !== userData?.['avatar'];
        const isFieldChanged = userData && userData.billing && formFields.some(field => formData[field] !== userData.billing[field]);
        if (isFieldChanged || isAvatarChanged) {
            dispatch(setFormChanged());
        } else {
            dispatch(resetFormChanged());
        }
    }

    const changeRegion = (value) => {
        const searchCountry = arrayCountries.find(country => country.value === value.toLowerCase());
        const regions = searchCountry && searchCountry['states'] ? Object.values(searchCountry['states']).map((region) => ({text: languageString === 'ru' ? region.name : region.name_en, value: region.code.toString()})) : [];
        setRegionList(regions)
    }

    const handleCheckCountry = (e, {value}) => {
        setFormData({
            ...formData,
            country: value
        });
        changeRegion(value);
        checkFormChanges();
    }

    const handleCityChange = (e, { value }) => {
        setFormData({
            ...formData,
            city: value,
            state: value,
        });
        checkFormChanges();
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        validate(name, value);
        setFormData({
            ...userData,
            [e.target.name]: e.target.value,
        });
        checkFormChanges();
    }

    const submitUserData = (e) => {
        e.preventDefault();
        setIsLoading(true);
        const query = JSON.stringify({
            billing: {
                // first_name: userData && userData.billing ? formData.first_name : '',
                // last_name: userData && userData.billing ? formData.last_name : '',
                // email: userData && userData.billing ? formData.email : '',
                // phone: userData && userData.billing ? formData.phone : '',
                // phone_country: userData && userData.billing ? formData.phone_country : '',
                country: userData && userData.billing ? formData.country.toUpperCase() : '',
                city: userData && userData.billing ? formData.city : '',
                state: userData && userData.billing ? formData.state : '',
            }
        })
        dispatch(updateUserData(props.token, userData.id, query, false, languageString))
            .then(() => {
                setIsLoading(false);
                setOpenRegionPopup(false)
            })
            .catch((error) => {
                setIsLoading(false);
            });
        dispatch(resetFormChanged());

    }

    const validate = (fieldName, value) => {
        let fieldErrors = {};
        if (fieldName === 'first_name') {
            if (!value) {
                fieldErrors = { [fieldName]: 'Имя обязательно для заполнения'};
            } else {
                fieldErrors = { [fieldName]: ''};
            }
        }
        if (fieldName === 'last_name') {
            if (!value) {
                fieldErrors = { [fieldName]: 'Фамилия обязательна для заполнения'};
            } else {
                fieldErrors = { [fieldName]: ''};
            }
        }
        // if (fieldName === 'email') {
        //     if (!value) {
        //     } else if (!isValidEmail(value)) {
        //     } else {
        //         fieldErrors = { [fieldName]: ''};
        //     }
        // }
        if (fieldName === 'phone') {
            if (!value) {
                fieldErrors = { [fieldName]: 'Телефон обязателен для заполнения'};
            } else {
                fieldErrors = { [fieldName]: ''};
            }
        }
        setErrors((prevErrors) => ({ ...prevErrors, ...fieldErrors }));
    }

    const ModalRegion = () => {
        return (
            <Modal className='venue-modal'
                   centered={false}
                   open={openRegionPopup}
                   onClose={() => setOpenRegionPopup(false)}
            >
                <Modal.Content className='venue-modal-content'>
                    <div className='venue-title-text'>Выберите свой регион</div>
                    <CloseIcon className="venue-modal-close-icon" />
                    <Form onSubmit={submitUserData}>
                        <FormField className='venue-field'>
                            <div className='venue-container'>
                                <Dropdown
                                    fluid
                                    search
                                    name='country'
                                    selection
                                    className='venue-input'
                                    placeholder='Страна'
                                    value={formData.country.toLowerCase()}
                                    options={arrayCountries}
                                    onChange={handleCheckCountry}
                                />
                            </div>
                        </FormField>
                        <FormField className='venue-field'>
                            <div className='venue-container'>
                                <Dropdown
                                    fluid
                                    search
                                    className='venue-input'
                                    name='state'
                                    placeholder='Регион'
                                    selection
                                    options={regionList}
                                    value={formData.state}
                                    onChange={handleCityChange}
                                    required
                                    basic={true}
                                />
                            </div>
                        </FormField>
                        <Button className='venue-modal-btn' type='submit' onClick={() => setOpenRegionPopup(false)}>Выбрать</Button>
                    </Form>
                </Modal.Content>
            </Modal>
        )
    }

    const handleLanguageChange = (newLanguage)=>{
        languageDispatch(setLanguage(newLanguage))
    }

    const selectedState = userData && userData.billing ? userData.billing.state : null;
    const countryData = userData && userData.billing ? countries.countries[userData.billing.country] : null;

    const desktopMenu = () => (
        <>
            <div className="header-top-banner">
                <div className='header-top-banner-content'>
                    <div>
                        <span className='header-main-title-text-1'> ОФИЦИАЛЬНЫЙ ИНТЕРНЕТ-МАГАЗИН </span>
                        <span className='header-main-title-text-2'>КОМПАНИИ ПРОТЕКТФИД</span>
                    </div>
                    <div className='header-main-title-text-3'>С ЗАБОТОЙ О ЖИВОТНЫХ</div>
                </div>
            </div>
            <div className="header-wrapper">
            <Grid className="header">
                <GridRow className='header-region-ctn'>
                    {token && userData && userData.billing ? (
                        <GridColumn width={4} className="venue-region" onClick={() => setOpenRegionPopup(true)}>
                            <b>
                                &nbsp;
                                {countryData
                                    ? languageString === 'ru' ? countryData.country_ru : countryData.country_en
                                    : "Не указан"}
                                {`, ${languageString !== 'ru'
                                    ? countryData.states.find(state => state.code == selectedState)?.name_en
                                    : countryData.states.find(state => state.code == selectedState)?.name_ru}`}
                            </b>
                        </GridColumn>
                    ) : (
                        <GridColumn width={4} className="header-region">
                            <RegionSelector className="header-region" />
                        </GridColumn>)}
                </GridRow>
                <GridRow className='header-search-block'>
                    <GridColumn className="header-logo-col">
                        <a href="/" onClick={(e) => { e.preventDefault(); navigate('/') }} aria-label="На главную">
                            <img className='header-logo' src={LogoEfeed} alt='eFeed — логотип'/>
                        </a>
                    </GridColumn>

                    <GridColumn className={`header-search-column ${isSearchExpanded ? 'expanded' : ''}`}>
                        <SearchForm />
                    </GridColumn>

                    <GridColumn className='header-icon-btn-ctn'>
                        <button className='header-icon-ctn' aria-label={t("search")} onClick={() => {
                            if (isMobile) {
                                setSidebarVisible(true);
                            } else {
                                setIsSearchExpanded(!isSearchExpanded);
                            }
                        }}>
                            <SearchIcon className='header-icon'/>
                            {t("search")}
                        </button>

                        {token && userData && userData.billing ? (
                            <Popup
                                trigger={
                                    <div className="venue-menu-item">
                                        <img src={UserIcon} height='20px'/>
                                        {userData.billing.first_name}
                                    </div>}
                                position='bottom center'
                                basic
                                hoverable
                                flowing
                                className='user-log-out-popup'

                            >
                                <div
                                    className='user-log-out-text'>{userData.billing.first_name} {userData.billing.last_name}</div>
                                <Divider fitted style={{margin: '5px 0'}}/>
                                <Button className='user-log-out-btn' onClick={() => {
                                    (
                                        dispatch(dropToken()), location.pathname === '/account' ? navigate(`/`) : null)
                                }}>Выйти</Button>
                            </Popup>

                        ) : isNewAuthLoggedIn ? (
                            <>
                                <button className="header-icon-ctn" aria-label={t("profile")} onClick={() => navigate('/profile')}>
                                    <img src={UserIcon} height='20px' alt=""/>
                                    {newAuthDisplayName || t("profile")}
                                </button>
                                <button className="header-icon-ctn" aria-label="Бонусные баллы" title="Бонусные баллы" onClick={() => navigate('/profile')}>
                                    <GiftFilled className="header-bonus-icon" />
                                    {Math.round(bonusPoints).toLocaleString('ru-RU')} баллов
                                </button>
                            </>
                        ) : (
                            <button className="header-icon-ctn" aria-label={t("loginRegistration")} onClick={handleOpenAuth}>
                                <LoginIcon className="header-icon"/>
                                {t("loginRegistration")}
                                {/*<UserLogin showModal={authVisible} {...props}/>*/}
                            </button>)}

                        <button className='header-icon-ctn' aria-label={t("favourites")} onClick={() => navigate(`/favorite`)}>
                            <HeartIcon className="header-icon"/>
                            {t("favourites")}
                        </button>
                        <button className='header-icon-ctn' aria-label="Корзина" onClick={() => navigate(`/cart`)}>
                            <span className="header-cart-icon-wrap">
                                <CartIcon className="header-icon"/>
                                {cartCount > 0 && <span className="cart-badge">{cartCount > 99 ? '99+' : cartCount}</span>}
                            </span>
                            Корзина
                        </button>
                        <button className='header-icon-ctn burger' aria-label="Меню" onClick={() => setSidebarVisible(true)}>
                            <BurgerMenu className='header-icon'/>
                            Меню
                        </button>

                    </GridColumn>
                </GridRow>

                <GridRow className="header-bottom-submenu" verticalAlign="middle">
                    <div
                        className="header-menu-items"
                        ref={menuRef}
                        onMouseDown={handleMouseDown}
                    >
                        {menuItems.length === 0 && isSecondaryMenuLoading ? (
                            <div className="header-menu-skeleton">
                                {Array(6).fill(null).map((_, i) => (
                                    <div key={i} className="header-menu-skeleton-item" />
                                ))}
                            </div>
                        ) : (
                            menuItems.map((item) => (
                                <div
                                    key={item.key}
                                    className={`header-menu-item ${activeSubmenu === item.key ? 'active' : ''}`}
                                    onClick={(e) => {
                                        if (hasDragged.current) return;
                                        handleSimpleCategoryClick(getMenuItemPath(item));
                                    }}
                                    onMouseEnter={() => item.hasSubmenu && openSubmenu(item.key)}
                                    onMouseLeave={closeSubmenuDelayed}
                                >
                                    {item.name}
                                </div>
                            ))
                        )}
                    </div>
                </GridRow>
                {activeSubmenu && submenuData[activeSubmenu] && (
                    <GridRow
                        className="category-submenu-container"
                        onMouseEnter={() => openSubmenu(activeSubmenu)}
                        onMouseLeave={closeSubmenuDelayed}
                    >
                        <GridColumn width={16}>
                            <div className="category-submenu" onClick={(e) => e.stopPropagation()}>
                                <div className="category-submenu-columns">
                                    {submenuData[activeSubmenu].columns.map((column) => (
                                        <div
                                            key={column.id}
                                            className="category-submenu-column"
                                            onClick={() => handleSimpleCategoryClick(getMenuItemPath(column))}
                                        >
                                            <div className="category-submenu-title">
                                                {(() => {
                                                    const parts = column.title.trim().split(/\s+/);
                                                    const first = parts[0];
                                                    const rest = parts.slice(1).join(' ');
                                                    return rest
                                                        ? <>{first}<br />{rest}</>
                                                        : first;
                                                })()}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </GridColumn>
                    </GridRow>
                )}
            </Grid>
            </div>
            <Modal
                className='venue-modal'
                centered={false}
                open={openQuestionPopup}
                onClose={() => setOpenQuestionPopup(false)}
            >
                <Modal.Content className="venue-modal-content">
                    <div className="venue-modal-text venue-title-text">{t("askUsQuestion")}</div>
                    <div className='venue-modal-text venue-mini-text'>*{t("questionShouldRelate")}</div>
                    <button className="venue-modal-close-btn" aria-label="Закрыть" onClick={() => setOpenQuestionPopup(false)}>
                        <CloseIcon className="venue-modal-close-icon" />
                    </button>

                    {/*{(nameDirty) && <div style={{color: 'red'}}></div>}*/}
                    <Input
                        className='venue-modal-placeholder'
                        type='text'
                        name='name'
                        placeholder={t("yourName")}
                        transparent
                        onChange={e => {
                            nameHandler(e);
                            handleUserNameChange(e)
                        }}
                        onBlur={e => blurHandler(e)}
                    />

                    <PhoneCountryMask
                        extraClass="edit-input-phone edit-input"
                        name="phone"
                        countries={listPhoneCountries}
                        country="RU"
                        loading={isFetching}
                        phone={phoneNumber}
                        handleChangeField={handleChangeField}
                        nameCountry={fields.PHONE_COUNTRY}
                        namePhone={fields.PHONE}
                        fluid={true}
                    />
                    <Input
                        className='venue-modal-placeholder'
                        type='text'
                        name='mail'
                        placeholder={t("email")}
                        transparent
                        onChange={e => mailHandler(e)}
                        onBlur={e => blurHandler(e)}
                    />
                    {(mailDirty && mailError) && <div style={{color: 'red'}}>{mailError}</div>}

                    {/*{(textDirty && textError) && <div style={{color: 'red'}}>{textError}</div>}*/}
                    <Input
                        className='venue-modal-placeholder'
                        type='text'
                        name='question'
                        placeholder={t("yourQuestion")}
                        transparent
                        onChange={e => {
                            textHandler(e)
                        }}
                        onBlur={e => blurHandler(e)}
                    />

                    <Button className="venue-modal-btn" onClick={handleSubmitQuestion}>{t("send")}</Button>

                </Modal.Content>
                {isLoading && (
                    <div className='venue-dimmer' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.45)', zIndex: 10 }}>
                        <Spin indicator={<LoadingOutlined spin style={{ fontSize: 24, color: '#fff' }} />} />
                        <span style={{ color: '#fff', marginLeft: 8 }}>Отправка сообщения</span>
                    </div>
                )}
            </Modal>

            <Modal className='venue-modal'
                   centered={false}
                   open={openRegionPopup}
                   onClose={() => setOpenRegionPopup(false)}
            >
                <Modal.Content className='venue-modal-content'>
                    <div className='venue-title-text'>Выберите свой регион</div>
                    <button className="venue-modal-close-btn" aria-label="Закрыть" onClick={() => setOpenRegionPopup(false)}>
                        <CloseIcon className="venue-modal-close-icon" />
                    </button>
                    <Form onSubmit={submitUserData}>
                        <FormField className='venue-field'>
                            <div className='venue-container'>
                                <Dropdown
                                    fluid
                                    search
                                    name='country'
                                    selection
                                    className='venue-input'
                                    placeholder='Страна'
                                    value={formData.country.toLowerCase()}
                                    options={arrayCountries}
                                    onChange={handleCheckCountry}
                                />
                            </div>
                        </FormField>
                        <FormField className='venue-field'>
                            <div className='venue-container'>
                                <Dropdown
                                    fluid
                                    search
                                    className='venue-input'
                                    name='state'
                                    placeholder='Регион'
                                    selection
                                    options={regionList}
                                    value={formData.state}
                                    onChange={handleCityChange}
                                    required
                                    basic={true}
                                />
                            </div>
                        </FormField>
                        <Button className='venue-modal-btn' type='submit'>Выбрать</Button>
                    </Form>
                </Modal.Content>
            </Modal>

            <AuthModal
                open={isAuthModalOpen || authVisible}
                onClose={handleCloseAuth}
            />
        </>
    );

    return (
        <>
            {desktopMenu()}
            <nav className="mobile-bottom-bar" aria-label="Мобильная навигация">
                <button className="mobile-bottom-bar-item" aria-label="Главная" onClick={() => navigate('/')}>
                    <HomeIcon className="mobile-bottom-bar-icon"/>
                    <span>Главная</span>
                </button>
                {token && userData && userData.billing ? (
                    <button className="mobile-bottom-bar-item" aria-label="Аккаунт" onClick={() => navigate('/account')}>
                        <LoginIcon className="mobile-bottom-bar-icon"/>
                        <span>{userData.billing.first_name}</span>
                    </button>
                ) : isNewAuthLoggedIn ? (
                    <button className="mobile-bottom-bar-item" aria-label="Профиль" onClick={() => navigate('/profile')}>
                        <span className="header-cart-icon-wrap">
                            <LoginIcon className="mobile-bottom-bar-icon"/>
                            {bonusPoints > 0 && (
                                <span className="cart-badge bonus-points-badge">
                                    {bonusPoints > 9999 ? '9999+' : Math.round(bonusPoints).toLocaleString('ru-RU')}
                                </span>
                            )}
                        </span>
                        <span>{newAuthDisplayName || 'Профиль'}</span>
                    </button>
                ) : (
                    <button className="mobile-bottom-bar-item" aria-label="Войти" onClick={handleOpenAuth}>
                        <LoginIcon className="mobile-bottom-bar-icon"/>
                        <span>Войти</span>
                    </button>
                )}
                <button className="mobile-bottom-bar-item" aria-label="Избранное" onClick={() => navigate('/favorite')}>
                    <HeartIcon className="mobile-bottom-bar-icon"/>
                    <span>Избранное</span>
                </button>
                <button className="mobile-bottom-bar-item" aria-label="Корзина" onClick={() => navigate('/cart')}>
                    <span className="header-cart-icon-wrap">
                        <CartIcon className="mobile-bottom-bar-icon"/>
                        {cartCount > 0 && <span className="cart-badge">{cartCount > 99 ? '99+' : cartCount}</span>}
                    </span>
                    <span>Корзина</span>
                </button>
            </nav>
        </>
    );
}